<template>
  <nav
    class="flex mb-5"
    aria-label="Breadcrumb">
    <ol class="inline-flex items-center gap-4">
      <li>
        <a :href="homeHref" class="text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
          <i class="far fa-house" />
        </a>
      </li>
      <li
        v-for="item, i in items"
        :key="item.title + i">
        <div class="flex items-center gap-4">
          <svg
            class="w-3 h-3 text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 9 4-4-4-4" />
          </svg>

          <a
            v-if="item.path"
            :href="item.path"
            class="text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
            {{ item.title }}
          </a>
          <span
            v-else
            class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ item.title }}</span>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true
  }
})

const homeHref = `/${window.location.pathname.split('/')[1]}/dashboard`
</script>
